import moment from "moment";
import { PROFESSION_TAB } from "../../framework/tab/tabUtilsConstants";

export const columnDefs = [
  {
    headerName: "Code",
    field: "professionId",
    width: 150,
  },
  {
    headerName: "Profession Name",
    field: "name",
    width: 220,
  },
  {
    headerName: "Company",
    field: "company",
    width: 220,
  },
  {
    headerName: "Created Time",
    field: "createdTime",
    width: 220,
  },
  {
    headerName: "Updated Time",
    field: "updatedTime",
    width: 220,
  },
];

export const columnDefsFunctions = {
  createdTime: {
    valueFormatter: (params) => {
      return moment(`${params.value}`).format("DD/MM/YYYY hh:mm A");
    },
  },
  updatedTime: {
    valueFormatter: (params) => {
      return moment(`${params.value}`).format("DD/MM/YYYY hh:mm A");
    },
  },
};
export const initial_state_profession = {
  type: PROFESSION_TAB,
  label: "Profession Master",
  allowMultipleTabs: false,
};
